module.exports = __webpack_public_path__ + "3ad61f50415db789ddb5dbe205d4e0e1.svg";